<script setup lang="ts">
import { Select } from 'primevue';
import Button from '../design-system/button.vue';

const site = useSiteStore();
const router = useRouter();

const regex = new RegExp('^\/[a-zA-Z-]+');
const routeText = ref('');

const allRoutes = computed(() => {
  const sitemapRoutes = Array.from(site.sitemapMap.keys());
  const routerRoutes = router.getRoutes().map((route) => {
    if (regex.test(route.path) && !route.path.includes('()'))
      return route?.path;
  });

  return [...new Set([...sitemapRoutes, ...routerRoutes])].sort();
});

const emits = defineEmits(['closeDevTools']);

function handleRouting() {
  router.push(routeText.value);
  emits('closeDevTools');
}
</script>

<template>
  <p class="text-xs text-base-priority my-3">
    Enter in the route you'd like to go to or choose from the available options
  </p>
  <div class="flex w-full gap-2">
    <Select
      v-model="routeText"
      :options="allRoutes"
      editable
      placeholder="/promotions"
      append-to="self"
    />
    <Button
      class="font-normal w-max justify-center"
      padding="md"
      rounding="md"
      @click="handleRouting"
    >
      Go
    </Button>
  </div>
</template>
